import { useState, useEffect } from "react";
import axios from "axios";
import "./Dashboard.css";
import { useNavigate } from "react-router-dom";

export default function Dashboard() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("view"); 
  const [products, setProducts] = useState([]);
  const [newProduct, setNewProduct] = useState({
    title: "",
    description: "",
    package_sizes: "",
    protein: "",
    benefits: "",
    img: null,
  });

  const [packs, setPacks] = useState([]);
  const [newPack, setNewPack] = useState(null);

  const [team, setTeam] = useState([]);
  const [newTeam, setNewTeam] = useState({ name: "", designation: "", img: null });

  const [error, setError] = useState("");
  const token = localStorage.getItem("token");

  const [infrastructure, setInfrastructure] = useState([]);
const [newInfra, setNewInfra] = useState(null);


  const logout = () => {
    localStorage.removeItem("token");
    navigate("/Admin/login");
  };

  // ================= FETCH =================
  const fetchProducts = async () => {
    try {
      const res = await axios.get("https://vangal-backend.onrender.com/api/products", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setProducts(res.data);
    } catch (err) {
      console.error(err);
      setError("Failed to fetch products");
    }
  };

  const fetchPacks = async () => {
    try {
      const res = await axios.get("https://vangal-backend.onrender.com/api/packs", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setPacks(res.data);
    } catch (err) {
      console.error(err);
      setError("Failed to fetch packs");
    }
  };

  const fetchTeam = async () => {
    try {
      const res = await axios.get("https://vangal-backend.onrender.com/api/team", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setTeam(res.data);
    } catch (err) {
      console.error(err);
      setError("Failed to fetch team members");
    }
  };

  const fetchInfrastructure = async () => {
  const res = await axios.get("https://vangal-backend.onrender.com/api/infrastructure", {
    headers: { Authorization: `Bearer ${token}` },
  });
  setInfrastructure(res.data);
};


  useEffect(() => {
    fetchProducts();
    fetchPacks();
    fetchTeam();
    fetchInfrastructure();
  }, []);

  // ================= ADD =================
// ================= ADD =================
const addProduct = async (e) => {
  e.preventDefault();
  try {
    // Upload image to Hostinger subdomain first (example using fetch)
    const uploadData = new FormData();
    uploadData.append("file", newProduct.img);
    uploadData.append("folder", "products");

    const uploadRes = await fetch("https://api.vangalfarm.co.in/upload-image.php", {
      method: "POST",
      body: uploadData,
    });
    const { url } = await uploadRes.json(); // get uploaded image URL

    await axios.post(
      "https://vangal-backend.onrender.com/api/products",
      {
        title: newProduct.title,
        description: newProduct.description,
        package_sizes: newProduct.package_sizes,
        protein: newProduct.protein,
        benefits: newProduct.benefits,
        img: url, // send full URL
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    setNewProduct({ title: "", description: "", package_sizes: "", protein: "", benefits: "", img: null });
    setActiveTab("view");
    fetchProducts();
  } catch (err) {
    console.error(err);
    setError("Failed to add product");
  }
};

const addPack = async (e) => {
  e.preventDefault();
  try {
    const uploadData = new FormData();
    uploadData.append("file", newPack);
     uploadData.append("folder", "packs");

    const uploadRes = await fetch("https://api.vangalfarm.co.in/upload-image.php", {
      method: "POST",
      body: uploadData,
    });
    const { url } = await uploadRes.json();

    await axios.post(
      "https://vangal-backend.onrender.com/api/packs",
      { img: url },
      { headers: { Authorization: `Bearer ${token}` } }
    );

    setNewPack(null);
    fetchPacks();
  } catch (err) {
    console.error(err);
    setError("Failed to add pack");
  }
};

const addTeamMember = async (e) => {
  e.preventDefault();
  try {
    const uploadData = new FormData();
    uploadData.append("file", newTeam.img);
    uploadData.append("folder", "team");

    const uploadRes = await fetch("https://api.vangalfarm.co.in/upload-image.php", {
      method: "POST",
      body: uploadData,
    });
    const { url } = await uploadRes.json();

    await axios.post(
      "https://vangal-backend.onrender.com/api/team",
      {
        name: newTeam.name,
        designation: newTeam.designation,
        img: url,
      },
      { headers: { Authorization: `Bearer ${token}` } }
    );

    setNewTeam({ name: "", designation: "", img: null });
    fetchTeam();
  } catch (err) {
    console.error(err);
    setError("Failed to add team member");
  }
};

const addInfrastructure = async (e) => {
  e.preventDefault();
  try {
    const uploadData = new FormData();
    uploadData.append("file", newInfra);
    uploadData.append("folder", "infrastructure");

    const uploadRes = await fetch("https://api.vangalfarm.co.in/upload-image.php", {
      method: "POST",
      body: uploadData,
    });
    const { url } = await uploadRes.json();

    await axios.post(
      "https://vangal-backend.onrender.com/api/infrastructure",
      { img: url },
      { headers: { Authorization: `Bearer ${token}` } }
    );

    setNewInfra(null);
    fetchInfrastructure();
  } catch (err) {
    console.error(err);
    setError("Failed to add infrastructure image");
  }
};


  // ================= DELETE =================
  const deleteProduct = async (id) => {
    if (!window.confirm("Are you sure you want to delete this product?")) return;
    try {
      await axios.delete(`https://vangal-backend.onrender.com/api/products/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      fetchProducts();
    } catch (err) {
      console.error(err);
      setError("Failed to delete product");
    }
  };

  const deletePack = async (id) => {
    if (!window.confirm("Are you sure you want to delete this pack?")) return;
    try {
      await axios.delete(`https://vangal-backend.onrender.com/api/packs/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      fetchPacks();
    } catch (err) {
      console.error(err);
      setError("Failed to delete pack");
    }
  };

  const deleteTeamMember = async (id) => {
    if (!window.confirm("Are you sure you want to delete this team member?")) return;
    try {
      await axios.delete(`https://vangal-backend.onrender.com/api/team/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      fetchTeam();
    } catch (err) {
      console.error(err);
      setError("Failed to delete team member");
    }
  };

  const deleteInfrastructure = async (id) => {
  if (!window.confirm("Delete this image?")) return;

  await axios.delete(`https://vangal-backend.onrender.com/api/infrastructure/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  fetchInfrastructure();
};


  return (
    <><section className="mobile-tablet-only">
  <div>
    <h2>Sorry Boss!</h2>
    <p>The admin panel is only accessible on laptops and desktops.</p>
  </div>
</section>
    <div className="dashboard-container">
      <header className="topbar">
        <h1 className="logo">Vangal Farms Admin</h1>
        <button className="logout-btn" onClick={logout}>Logout</button>
      </header>

      <div className="main-wrapper">
        <aside className="sidebar anim anim-bottom">
          <ul>
            <li className={activeTab === "view" ? "active" : ""} onClick={() => setActiveTab("view")}>View Products</li>
            <li className={activeTab === "add" ? "active" : ""} onClick={() => setActiveTab("add")}>Add Product</li>
            <li className={activeTab === "packs" ? "active" : ""} onClick={() => setActiveTab("packs")}>Available Packs</li>
            <li className={activeTab === "team" ? "active" : ""} onClick={() => setActiveTab("team")}>Team Members</li>
            <li className={activeTab === "infrastructure" ? "active" : ""} onClick={() => setActiveTab("infrastructure")}>Our Infrastructure</li>
          </ul>
        </aside>

        <main className="content">
          {error && <p className="error-msg">{error}</p>}

          {/* ========== PRODUCTS ========== */}
          {activeTab === "view" && (
            <div className="products-list-section">
              <h2>All Products</h2>
              <table className="products-table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Image</th>
                    <th>Title</th>
                    {/* <th>Description</th>
                    <th>Package Sizes</th>
                    <th>Protein</th>
                    <th>Benefits</th> */}
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {products.map((p) => (
                    <tr key={p.id}>
                      <td>{p.id}</td>
                      <td><img src={p.img} alt={p.title} style={{ width: "80px", borderRadius: "8px" }} /></td>
                      <td>{p.title}</td>
                      {/* <td>{p.description}</td>
                      <td>{p.packageSize.join(", ")}</td>
                      <td>{p.protein}</td>
                      <td>{p.benefits.join(", ")}</td> */}
                      <td><button className="delete-btn" onClick={() => deleteProduct(p.id)}>Delete</button></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {activeTab === "add" && (
            <div className="add-product-section">
              <h2>Add New Product</h2>
              <form onSubmit={addProduct} className="add-product-form">
                <input type="text" placeholder="Title" value={newProduct.title} onChange={(e) => setNewProduct({...newProduct, title: e.target.value})} required />
                <textarea placeholder="Description" value={newProduct.description} onChange={(e) => setNewProduct({...newProduct, description: e.target.value})} required />
                <input type="text" placeholder="Package Sizes (comma separated)" value={newProduct.package_sizes} onChange={(e) => setNewProduct({...newProduct, package_sizes: e.target.value})} required />
                <input type="text" placeholder="Protein" value={newProduct.protein} onChange={(e) => setNewProduct({...newProduct, protein: e.target.value})} required />
                <input type="text" placeholder="Benefits (comma separated)" value={newProduct.benefits} onChange={(e) => setNewProduct({...newProduct, benefits: e.target.value})} required />
                <input type="file" onChange={(e) => setNewProduct({...newProduct, img: e.target.files[0]})} required />
                <button type="submit">Add Product</button>
              </form>
            </div>
          )}

          {/* ========== PACKS ========== */}
          {activeTab === "packs" && (
            <div className="packs-section">
              <h2>Available Packs</h2>
              <div className="packs-list">
                {packs.map(p => (
                  <div key={p.id} className="pack-item">
                    <img src={p.img} alt="Pack" />
                    <button className="delete-btn" onClick={() => deletePack(p.id)}>Delete</button>
                  </div>
                ))}
              </div>
              <form onSubmit={addPack} className="add-pack-form">
                <input type="file" onChange={e => setNewPack(e.target.files[0])} required />
                <button type="submit">Add Pack</button>
              </form>
            </div>
          )}

          {/* ========== TEAM MEMBERS ========== */}
          {activeTab === "team" && (
            <div className="team-section">
              <h2>Team Members</h2>
              <div className="team-list">
                {team.map(t => (
                  <div key={t.id} className="team-item">
                    <img src={t.img} alt={t.name} />
                    <div className="team-info">
                      <p className="team-name">{t.name}</p>
                      <p className="team-designation">{t.designation}</p>
                    </div>
                    <button onClick={() => deleteTeamMember(t.id)}>Delete</button>
                  </div>
                ))}
              </div>
              <form onSubmit={addTeamMember} className="add-team-form">
                <input type="text" placeholder="Name" value={newTeam.name} onChange={e => setNewTeam({...newTeam, name: e.target.value})} required />
                <input type="text" placeholder="Designation" value={newTeam.designation} onChange={e => setNewTeam({...newTeam, designation: e.target.value})} required />
                <input type="file" onChange={e => setNewTeam({...newTeam, img: e.target.files[0]})} required />
                <button type="submit">Add Team Member</button>
              </form>
            </div>
          )}

          {activeTab === "infrastructure" && (
  <div className="infra-section">
    <h2>Infrastructure Images</h2>

    <div className="infra-list">
      {infrastructure.map(i => (
        <div key={i.id} className="infra-item">
          <img src={i.img} alt={`Infra ${i.id}`} />
          <button onClick={() => deleteInfrastructure(i.id)}>Delete</button>
        </div>
      ))}
    </div>

    <form onSubmit={addInfrastructure} className="infra-form">
      <input
        type="file"
        onChange={e => setNewInfra(e.target.files[0])}
        required
      />
      <button type="submit">Add Image</button>
    </form>
  </div>
)}


        </main>
      </div>
    </div>
    </>
  );
}
